// src/legal/legalConfig.ts
//
// `config/legal`: the manifest as the server published it, with the dates of
// every version. Read once when the dialog or the list is needed, never for a
// user who is up to date.
import { doc, getDoc, getFirestore } from 'firebase/firestore';
import type { LegalManifest } from './legalState';

// Before the first publish run there is no document. That is not a failure:
// nothing is published, so nothing can be outstanding, whatever the app
// carries in its bundle. Answering with the bundled manifest here would offer
// a text the server does not know yet and then refuse its acceptance.
const NOTHING_PUBLISHED: LegalManifest = { revision: 0, documents: [] };

/** The published manifest; empty before the first publish run; null when unusable. */
export async function readPublishedLegal(): Promise<LegalManifest | null> {
    const snapshot = await getDoc(doc(getFirestore(), 'config', 'legal'));
    if (!snapshot.exists()) return NOTHING_PUBLISHED;
    const data = snapshot.data();
    if (typeof data.revision !== 'number' || !Array.isArray(data.documents)) {
        return null;
    }
    return { revision: data.revision, documents: data.documents };
}
